export const alerts: any = {
    firstNotification: {
        text: 'Accede a El Nuevo Día ePaper, la réplica digital del periódico impreso.',
        action: 'Conoce más'
    },
    secondNotification: {
        text: 'Solo para ti Suscriptor, participa de concursos y eventos exclusivos.',
        action: 'Ver más'
    },
    thirdNotification: {
        text: 'Obtén acceso ilimitado a todo el contenido de endi.com al activar tu acceso digital.',
        action: 'Actívalo aquí'
    },
};

export const alertsModals: any = {
    alertsInformationModal: {
        title: 'Concursos y Eventos',
        description: 'Solo para ti Suscriptor: participa de concursos y eventos exclusivos.',
        cta: 'Llama hoy al (787)-641-1346 y estarás participando.'
    },
};


// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/home/alerts-notifications.ts